import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

type InviteCodeContextValue = {
  inviteCode: string | null
}

const InviteCodeContext = createContext<InviteCodeContextValue>({ inviteCode: null })

export function useInviteCode(): InviteCodeContextValue {
  return useContext(InviteCodeContext)
}

export const InviteCodeProvider = ({ children }: PropsWithChildren) => {
  const inviteCode = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get('invite')
  }, [])

  const value = useMemo(() => ({ inviteCode }), [inviteCode])

  return <InviteCodeContext.Provider value={value}>{children}</InviteCodeContext.Provider>
}
